import React from 'react';

import dynamic from 'next/dynamic';

import Price from '@components/ui/price';
import { Separator } from '@components/formStyles';
import { getCurrencySymbol } from '@utils/utils';
import { getDiscountType } from '@components/views/hotel/utils';
import ListWorldLogo from '@components/ui/ListWorldLogo';
import DiscountLabel from '@components/ui/cards/ListingItem/next/discount/DiscountLabel';
import CustomIcon from '@components/utils/CustomIcon';
import { WorldLogoWhite } from '@assets/icons';
import Typography from '@components/Typography';

import { SummaryCardPriceProps } from './utils';
import {
  RightCol,
  DiscountWrapper,
  StyledButtonDesktop,
  CampaignLabelWrapper,
  RightWrapper,
  PriceDetails,
  FlexEnd,
  WorldPriceWrapper,
  WorldPriceTextWrapper,
  SeparatorWorld,
  WorldPriceContainer,
} from './SummaryCardStyle';

const ExpediaPrice = dynamic(() => import('@components/ui/price/ExpediaPrice'));

const OriginalPrice = dynamic(
  () => import('@components/ui/price/OriginalPrice')
);

const SummaryCardDesktopPrice = ({
  isExpedia,
  entryDateMissing,
  bankInstallMentForWorld,
  showSeturEmployeePrice,
  prices,
  roomInformation,
  onNavigate,
  isPackage,
  countryCode,
  basketHotelCount,
}: SummaryCardPriceProps) => {
  return (
    <RightCol>
      <RightWrapper>
        {countryCode === 'TR' || (countryCode === 'CY' && !isPackage) ? (
          <CampaignLabelWrapper>
            <ListWorldLogo label={bankInstallMentForWorld} />
          </CampaignLabelWrapper>
        ) : null}
        {prices?.price && !showSeturEmployeePrice ? (
          <FlexEnd>
            {isPackage ? null : prices.discountRatio ? (
              <DiscountWrapper>
                <DiscountLabel
                  discount={prices.discountRatio}
                  type={getDiscountType(prices.type)}
                />
              </DiscountWrapper>
            ) : null}

            <Price
              total={
                prices.originalDiscountedPrice !== prices.originalPrice &&
                isExpedia
              }
              price={prices.price}
              originalPrice={prices.originalPrice}
              orginalDiscountedPrice={prices.originalDiscountedPrice}
              originalPriceSize={16}
              originalPriceCurrency={getCurrencySymbol(
                prices.originalCurrencyCode
              )}
              currency={getCurrencySymbol(prices.currencyCode)}
            >
              {isExpedia ? (
                <ExpediaPrice
                  total={
                    prices.originalDiscountedPrice !== prices.originalPrice
                  }
                  originalPriceSize={16}
                  orginalDiscountedPrice={prices.originalDiscountedPrice}
                  originalPriceCurrency={getCurrencySymbol(
                    prices.originalCurrencyCode
                  )}
                  originalPrice={prices.originalPrice}
                  currency={getCurrencySymbol(prices.currencyCode)}
                  price={prices.price}
                />
              ) : (
                <>
                  {prices.discountRatio ? (
                    <>
                      {prices.originalPrice !== prices.price &&
                      !entryDateMissing &&
                      !isPackage ? (
                        <OriginalPrice
                          size={16}
                          price={prices.originalPrice}
                          currency={getCurrencySymbol(
                            prices.originalCurrencyCode
                          )}
                          noLine={false}
                        />
                      ) : null}
                    </>
                  ) : (
                    <>
                      {prices.originalPrice !== prices.price &&
                      !entryDateMissing &&
                      !isPackage ? (
                        <OriginalPrice
                          size={16}
                          price={prices.originalPrice}
                          currency={getCurrencySymbol(
                            prices.originalCurrencyCode
                          )}
                          noLine={true}
                        />
                      ) : null}
                    </>
                  )}
                </>
              )}
            </Price>
            {basketHotelCount &&
            basketHotelCount > 0 ? null : prices.bankPosPromotionPrice &&
              prices.bankPosPromotionRate ? (
              <WorldPriceWrapper>
                <WorldPriceContainer>
                  <WorldPriceTextWrapper>
                    <CustomIcon
                      icon={WorldLogoWhite}
                      width={56}
                      height={9}
                      color='NL0'
                    />
                    <Typography
                      variant='caption3'
                      weight='Bold'
                      color='NL0'
                      style={{ lineHeight: 'normal' }}
                    >
                      'e
                    </Typography>
                  </WorldPriceTextWrapper>
                  <Typography
                    variant='caption3'
                    weight='Bold'
                    color='NL0'
                    style={{ lineHeight: 'normal' }}
                  >
                    {`Özel %${prices.bankPosPromotionRate}`}
                  </Typography>
                </WorldPriceContainer>
                <SeparatorWorld />
                <Price
                  price={prices.bankPosPromotionPrice}
                  currency={getCurrencySymbol(prices.currencyCode)}
                  color='NL0'
                />
              </WorldPriceWrapper>
            ) : null}
            <PriceDetails>'den başlayan fiyatlarla</PriceDetails>
            <PriceDetails isBold>{roomInformation}</PriceDetails>
          </FlexEnd>
        ) : null}
        <Separator />

        <StyledButtonDesktop variant='Primary' onClick={onNavigate}>
          Odaları Gör
        </StyledButtonDesktop>
      </RightWrapper>
    </RightCol>
  );
};

export default SummaryCardDesktopPrice;
